import React from "react";

import {
    Banner,
    Button,
    FieldGrid,
    LabeledField,
    SectionCard,
    Stack,
    TextInput,
} from "shared/ui";
import { digitsOnly } from "shared/lib/formInput";
import { formatPhoneNumber } from "shared/lib/phoneNumber";

import { CONFIRMATION_CODE_LENGTH, MIN_PASSWORD_LENGTH } from "features/Account/constants";
import { useAccountContext } from "features/Account/context";

import { Actions, CodeField } from "./styles";

const formatCountdown = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const rest = seconds % 60;

    return `${minutes}:${rest < 10 ? "0" : ""}${rest}`;
};

export const PasswordCard = () => {
    const state = useAccountContext();
    const { account } = state;

    if (!account) return null;

    const phone = formatPhoneNumber(account.phoneNumber);

    return (
        <SectionCard
            title="Пароль"
            description="Новый пароль вступит в силу после подтверждения кодом из SMS"
        >
            {state.codeRequested ? (
                <Stack>
                    <Banner tone="info" title={`Код отправлен на ${phone}`}>
                        {state.codeExpiresInSeconds > 0
                            ? `Код действует ещё ${formatCountdown(state.codeExpiresInSeconds)}`
                            : "Срок действия кода истёк — запросите новый"}
                    </Banner>

                    <CodeField>
                        <LabeledField
                            label="Код из SMS"
                            hint={`${CONFIRMATION_CODE_LENGTH} цифры из сообщения`}
                        >
                            <TextInput
                                value={state.confirmationCode}
                                onChange={(value) =>
                                    state.setConfirmationCode(
                                        digitsOnly(value, CONFIRMATION_CODE_LENGTH)
                                    )
                                }
                                placeholder="0000"
                            />
                        </LabeledField>
                    </CodeField>

                    <Actions>
                        <Button
                            disabled={!state.isConfirmationCodeValid || state.submitting}
                            onClick={state.submitPassword}
                        >
                            Сохранить пароль
                        </Button>
                        <Button
                            variant="outlined"
                            color="neutral"
                            disabled={state.submitting}
                            onClick={state.requestCode}
                        >
                            Отправить код ещё раз
                        </Button>
                        <Button variant="text" color="neutral" onClick={state.cancelCodeRequest}>
                            Отмена
                        </Button>
                    </Actions>
                </Stack>
            ) : (
                <>
                    <FieldGrid $min={240}>
                        <LabeledField
                            label="Новый пароль"
                            hint={
                                state.passwordError ||
                                `Латинские буквы, цифры и спецсимволы, минимум ${MIN_PASSWORD_LENGTH} символа`
                            }
                            hintTone={state.passwordError ? "danger" : "default"}
                        >
                            <TextInput
                                value={state.password}
                                onChange={state.setPassword}
                                type="password"
                                placeholder="••••••"
                            />
                        </LabeledField>

                        <LabeledField
                            label="Повторите пароль"
                            hint={state.confirmPasswordError}
                            hintTone="danger"
                        >
                            <TextInput
                                value={state.confirmPassword}
                                onChange={state.setConfirmPassword}
                                type="password"
                                placeholder="••••••"
                            />
                        </LabeledField>
                    </FieldGrid>

                    <Actions>
                        <Button
                            disabled={!state.isPasswordValid || state.submitting}
                            onClick={state.requestCode}
                        >
                            Получить код подтверждения
                        </Button>
                    </Actions>
                </>
            )}
        </SectionCard>
    );
};
